<!--JIRA ISSUE COLLECTOR-->
<ng-container *ngIf="!isProd">
  <ngx-jira-issue-collector [configuration]="config"></ngx-jira-issue-collector>
</ng-container>
<!--END JIRA ISSUE COLLECTOR-->
